import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Form, Row, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { FormText } from "./MyForm";
import { FaTrash } from "react-icons/fa";

const PatientTagForm = ({ tag, deleteTag }) => {
  const [updatedTag, setUpdatedTag] = useState([]);
  const [comment, setComment] = useState(tag.comment || "");

  const clinicDetails = useSelector((state) => state.clinicDetails);
  const { clinic } = clinicDetails;

  useEffect(() => {
    tag.label = updatedTag && updatedTag[0] ? updatedTag[0].label : tag.label;
    tag.tagId = updatedTag && updatedTag[0] ? updatedTag[0]._id : tag.tagId;
    tag.comment = comment;
  }, [updatedTag, comment]);
  return (
    <>
      <Row className=" d-flex align-self-center g-2">
        {clinic?.patientTags && tag && (
          <>
            <Col xs={12} md={6} lg={5} className="my-1">
              <Typeahead
                allowNew
                placeholder="Type like: Smoker"
                defaultInputValue={
                  tag.tagId &&
                  clinic.patientTags.find(
                    (pt) => pt._id.toString() === tag.tagId.toString(),
                  )
                    ? clinic.patientTags.find(
                        (pt) => pt._id.toString() === tag.tagId.toString(),
                      ).label
                    : ""
                }
                options={clinic.patientTags.filter((t) => !t.isHide)}
                onChange={(e) => setUpdatedTag(e)}
                id="patientTags"
              />
            </Col>

            <Col xs={12} md={6} lg={5} className="my-1">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Type like: 10 years ago"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={12} lg={2} className="my-1 text-center">
              <Button
                className="btn w-100 d-lg-inline-block"
                variant="outline-danger"
                onClick={() => deleteTag(tag)}
              >
                <FaTrash />
              </Button>
            </Col>
          </>
        )}
      </Row>

      <hr className="border border-success" />
    </>
  );
};

export default PatientTagForm;
